'use client';

import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { Image, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import type { CuratorEventItemDTO } from '@musinsa/services-curator';
import Link from 'next/link';
import type { FC } from 'react';

interface CuratorEventCardProps {
  event: CuratorEventItemDTO;
  eventsIndex: number;
}

export const CuratorEventCard: FC<CuratorEventCardProps> = ({ event, eventsIndex }) => {
  const { displayPeriod, image, label, link, title } = event;
  const { service } = useDeviceInfo();

  const logMusinsaClick = () => {
    if (service !== SERVICE.MUSINSA) return;

    amplitudeSendEvent({
      action_name: 'click',
      component_name: 'button',
      event_name: 'click_button',
      filter_value: event.remainingDays || 'pre',
      from: getScreenName(),
      id: `${eventsIndex}`,
      section_name: `${event.eventType}_${title}`,
      type: event.sourceType,
    });

    pushDataLayer('click_content', {
      brand_id: GTM_NOTSET_STRING,
      content_id: `${eventsIndex}`,
      content_name: `${event.eventType}_${title}`,
      content_type: event.sourceType,
      index: `${eventsIndex}`,
      section_index: '1',
      section_name: 'events',
    });
  };

  return (
    <Link href={link} className="flex flex-col" onClick={logMusinsaClick}>
      <div className="w-full aspect-[3/2] overflow-hidden relative bg-base-gray-3">
        {Boolean(label?.length) && (
          <span className="absolute z-10 bottom-2 left-2 rounded px-1.5 py-0.5 bg-base-gray-11/80 text-white text-[11px] leading-[14px] font-medium">
            {label}
          </span>
        )}
        <Image
          objectFit="cover"
          heightFull
          alt={title}
          direction="horizontal"
          size="cover"
          src={image}
        />
      </div>
      <div className="flex flex-col gap-1 px-3 pt-3 pb-6 h-[90px]">
        <Typography variant="body13pxMed" className="line-clamp-2 text-ellipsis">
          {title}
        </Typography>
        <Typography variant="textEtc11pxReg" className="text-base-gray-9">
          {displayPeriod}
        </Typography>
      </div>
    </Link>
  );
};
